module.exports = __webpack_public_path__ + "assets/img/33_9_big.5c24d8f3.jpg";